import type {
	VideoCategory,
	VideoCategoryShallow,
	VideoPreview,
} from "@brookbush/types";

import type { GetStaticProps } from "next";
import { NextSeo } from "next-seo";

import { VideosCatalogue } from "./components";
import VideosOverview from "./components/VideosOverview";
import { GridLayout } from "~/layouts";
import type { NextPageWithProps } from "~/types";
import fetcher from "~/utils/fetcher.client";

interface VideosPageProps {
	shallowCategories: VideoCategoryShallow[];
	featuredVideos: VideoPreview[];
	categories: VideoCategory[];
}

const VideosPage: NextPageWithProps<VideosPageProps> = ({
	shallowCategories,
	featuredVideos,
	categories,
}) => {
	return (
		<>
			<NextSeo title="Videos" description="Brookbush Institute Videos" />

			<GridLayout.Sidebar className="z-20 laptop:block hidden">
				<VideosCatalogue shallowCategories={shallowCategories} />
			</GridLayout.Sidebar>

			<GridLayout.Body>
				<VideosOverview
					categories={categories}
					featuredVideos={featuredVideos}
				/>
			</GridLayout.Body>
		</>
	);
};

VideosPage.Layout = GridLayout;

export const getStaticProps: GetStaticProps<
	{},
	{
		categorySlugs: string[];
	}
> = async () => {
	const [shallowCategories, featuredVideos, categories] = await Promise.all([
		fetcher("/videos/categories/shallow"),
		fetcher("/videos/featured"),
		fetcher("/videos/categories"),
	]);

	return {
		props: {
			shallowCategories,
			featuredVideos,
			categories,

			breadcrumbs: [
				{
					name: "Videos",
					href: "/videos",
				},
			],
		},
	};
};

export default VideosPage;
